import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/book/$workId/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/work/$workId', params, replace: true })
    },
})
